import type { TOC } from '@ember/component/template-only';

import styles from './fixed-kpi-header-item.module.css';

interface HotelShortTermRentalFixedKpiHeaderItemSignature {
  Args: {
    kpiCategoryFirst: unknown;
    kpiCategorySecond: unknown;
    showSecondValue: unknown;
    title: unknown;
    valueFirst: unknown;
    valueSecond: unknown;
  };
}

const HotelShortTermRentalFixedKpiHeaderItem = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div class={{styles.item}}>
    <div class="{{styles.name}} text-300--regular">
      {{@title}}
      <div>
        <span class="text-200--bold">{{@kpiCategoryFirst}}</span>
        <span class="text-200--regular ml-100">{{@valueFirst}}</span>
      </div>
      {{#if @showSecondValue}}
        <div>
          <span class="text-200--bold">{{@kpiCategorySecond}}</span>
          <span class="text-200--regular ml-100">{{@valueSecond}}</span>
        </div>
      {{/if}}
    </div>
  </div>
</template> satisfies TOC<HotelShortTermRentalFixedKpiHeaderItemSignature>;

export default HotelShortTermRentalFixedKpiHeaderItem;
